import AccountModalTab from '~/constants/accountModalTab';
import { useIsLoggedIn } from '~/context/common/UserContext';
import { openAccountModal } from '~/utilities/accountModal';

type OwnProps = {
  callerIdentifier: string;
  headerModalTitle: string;
  modalLink: string;
  openModal: (() => void) | null;
  router: Record<string, any>;
  successHandler: (() => void) | null;
  tab: AccountModalTab;
};

const useCustomHeaderEvents = ({
  callerIdentifier = 'AccountCreationForm',
  headerModalTitle = 'WELCOME TO CARVANA',
  tab,
  successHandler
}: Partial<OwnProps>) => {
  const handleSuccess = async () => {
    if (successHandler) {
      successHandler();
    }
  };

  return () =>
    openAccountModal({
      modalTitle: headerModalTitle,
      onSuccess: () => handleSuccess(),
      tab,
      callerIdentifier
    });
};

export default function useHeaderAccountModal({
  callerIdentifier = 'AccountCreationForm',
  headerModalTitle = 'WELCOME TO CARVANA',
  openModal = null,
  successHandler = null,
  tab = AccountModalTab.SignIn
}: Partial<OwnProps> = {}) {
  const isLoggedIn = useIsLoggedIn();
  const openHeaderModal = useCustomHeaderEvents({
    headerModalTitle,
    tab,
    callerIdentifier,
    successHandler
  });

  return () => {
    if (!isLoggedIn) {
      openHeaderModal();

      return;
    }

    if (openModal) {
      openModal();

      return;
    }
  };
}
